document.addEventListener('DOMContentLoaded', () => {
  const stylingTipSlider = new Swiper('[data-styling-tip-slider]', {
    slidesPerView: 1.31,
    spaceBetween: 5,
    grabCursor: true,
    navigation: {
      nextEl: '[data-styling-tip-next]',
      prevEl: '[data-styling-tip-prev]',
    },
    breakpoints: {
      768: {
        slidesPerView: 4.6,
      },
    },
  });

  const popup = document.querySelector('[data-styling-tip-popup]');
  const popupContent = popup.querySelector('[data-styling-tip-popup-gallery]');
  const closeBtn = popup.querySelector('[data-styling-tip-popup-close]');
  let popupSwiper = null;

  function openPopup(images) {
    popupContent.innerHTML = `
      <div class="swiper-wrapper">
        ${images.map(src => `
          <div class="swiper-slide">
            <img src="${src}" class="styling-tip__popup-image" fetchpriority="low">
          </div>
        `).join('')}
      </div>
      <div class="swiper-button-prev" data-styling-tip-popup-prev></div>
      <div class="swiper-button-next" data-styling-tip-popup-next></div>
      <div class="swiper-scrollbar" data-styling-tip-popup-scrollbar></div>
    `;

    popupSwiper = new Swiper(popupContent, {
      slidesPerView: 1,
      navigation: {
        nextEl: '[data-styling-tip-popup-next]',
        prevEl: '[data-styling-tip-popup-prev]'
      },
      scrollbar: {
        el: '[data-styling-tip-popup-scrollbar]',
        draggable: false
      },
      keyboard: { 
        enabled: true 
      },
      on: {
        init() {
          popup.classList.add('active');
        }
      }
    });
  }

  function closePopup() {
    popup.classList.remove('active');
    if (popupSwiper) {
      popupSwiper.destroy(true, true);
      popupSwiper = null;
    }
  }

  document.querySelectorAll('[data-styling-tip-slider] .swiper-slide').forEach(slide => {
    slide.addEventListener('click', () => {
      const gallery = JSON.parse(slide.dataset.gallery);
      openPopup(gallery);
    });
  });

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', e => {
    if (e.target === popup) closePopup();
  })

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && popup.classList.contains('active')) closePopup();
  })
});
